
import FontFaceObserver from "fontfaceobserver";

var openSansFont = new FontFaceObserver('Open Sans');
var caveatFont = new FontFaceObserver('Caveat');

openSansFont.load(null, 8000).then(function () {
    document.documentElement.className += " open-sans-loaded";
});

caveatFont.load(null, 8000).then(function () {
    document.documentElement.className += " caveat-loaded";
});
